import { render, staticRenderFns } from "./ManageTopping.vue?vue&type=template&id=40965eb4&"
import script from "./ManageTopping.vue?vue&type=script&lang=js&"
export * from "./ManageTopping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports